import MitHomePage from '../pages/MitHomePage.vue';
import MitUserPage from '../pages/MitUserPage.vue';
import MitAppsPage from '../pages/MitAppsPage.vue'


export const defaultRoute = 'home';

export function getAppRoutes(MitUserModel, routerGuardAccessCheck) {
    return [
      {
        path: '/home',
        name: 'home',
        component: MitHomePage,
        props: true,
      },
      {
        path: '/users',
        name: 'users',
        component: MitUserPage,
        meta: { allowedRole: MitUserModel.ROLES.ADMIN },
        props: true,
        beforeEnter(to, from, next) { routerGuardAccessCheck(to, from, next) }
      },
      {
        path: '/apps',
        name: 'apps',
        component: MitAppsPage,
        meta: { allowedRole: MitUserModel.ROLES.ADMIN },
        props: true,
        beforeEnter(to, from, next) { routerGuardAccessCheck(to, from, next) }
      }
    ]
}
